import { FormControl } from '@angular/forms';
import { GroupMarketingPreferenceFormField } from '../../models/group-marketing-preference/group-marketing-preference-form-field.enum';
import { GroupMarketingPreferenceForm } from '../../models/group-marketing-preference/group-marketing-preference-form.interface';

export const mockGroupMarketingPreferenceForm: GroupMarketingPreferenceForm = {
  [GroupMarketingPreferenceFormField.Email]: new FormControl(true, {
    nonNullable: true,
  }),
  [GroupMarketingPreferenceFormField.Post]: new FormControl(true, {
    nonNullable: true,
  }),
  [GroupMarketingPreferenceFormField.Telephone]: new FormControl(true, {
    nonNullable: true,
  }),
};
